import React from "react";

class TileSelect extends React.Component<TitleSelectProps> {
  render() {
    return (
      <div
        className="c-tile-select"
        onClick={(e: React.MouseEvent) => {
          if (this.props.onClick) {
            e.preventDefault(); // avoid bubbling up, resulting in triggering multiple times
            this.props.onClick(e);
          }
        }}
      >
        <label className="c-tile-select__label" htmlFor={this.props.id}>
          <input
            className="c-tile-select__input"
            type="checkbox"
            id={this.props.id}
            value={this.props.id}
            name={this.props.id}
          />
          <span className="c-tile-select__body">
            <span className="c-tile-select__body-top u-text-center">
              {this.props.icon && (
                <i
                  className={`c-tile-select__icon  c-icon  c-icon--[${this.props.icon}]`}
                  aria-hidden="true"
                />
              )}
              <span className="u-visually-hidden">{this.props.title}</span>
              <span className="c-tile-select__title">{this.props.title}</span>
              <span className="c-tile-select__text">{this.props.txtBody}</span>
            </span>
            <span className="c-tile-select__body-bottom">
              <span className="c-btn  c-tile-select__button">
                <span className="c-btn__text">{this.props.txtButton}</span>
              </span>
            </span>
          </span>
        </label>
      </div>
    );
  }
}

type TitleSelectProps = {
  id: string;
  title?: string;
  txtBody?: string;
  txtButton?: string;
  icon?: string;
  onClick?: Function;
};

export { TileSelect };
